import { Button } from "@/components/ui/button";
import { ROUTES } from "@/constants/routes";
import { cn } from "@/utils";
import { ChevronLeft } from "lucide-react";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage: FC<{ className?: string }> = function ({ className }) {
  const navigate = useNavigate();

  return (
    <div
      className={cn(
        "flex min-h-dvh flex-col items-center justify-center py-16",
        className,
      )}
    >
      <h1 className="mb-6 text-2xl font-medium dark:text-white md:text-4xl">
        Page not found
      </h1>
      <p className="mb-6 w-4/5 max-w-xl text-center text-lg text-neutral-500 dark:text-neutral-300">
        Oops! Looks like you followed a bad link. If you think this is a problem
        with us, please tell us.
      </p>
      <Button onClick={() => navigate(ROUTES.HOME)}>
        <ChevronLeft /> Go back home
      </Button>
    </div>
  );
};

export default NotFoundPage;
